import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { BotaoLogoutComponent } from "./botao-logout/botao-logout.component";
import { MenuPrincipalComponent } from "./menu-principal/menu-principal.component";

@NgModule({
  declarations: [MenuPrincipalComponent, BotaoLogoutComponent],
  imports: [IonicModule],
  exports: [
    BotaoLogoutComponent,
    CommonModule,
    IonicModule,
    MenuPrincipalComponent,
  ],
  providers: [BotaoLogoutComponent],
})
export class CompartilhadoModule {}
